import { createApiHooks, schemaToQueryParameters } from '@apis/next/common';
import {
  AdminCommodityForm,
  Commodity,
  CommodityPages,
  CommoditySearchQuery,
  PatchCommodity,
  PostCommodity,
} from '@models/next/Commodity';
import { z } from 'zod';

export const commodityApis = createApiHooks('/commodity', [
  {
    method: 'get',
    path: '/',
    parameters: schemaToQueryParameters(CommoditySearchQuery),
    response: CommodityPages,
  },
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
    ],
    response: Commodity,
  },
  {
    method: 'patch',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
      {
        type: 'Body',
        name: 'body',
        schema: PatchCommodity,
      },
    ],
    response: Commodity,
  },
  {
    method: 'post',
    path: '/',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PostCommodity,
      },
    ],
    response: Commodity,
  },
  {
    method: 'delete',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
    ],
    response: z.unknown(),
  },
]);

export const dashboardCommodityApis = createApiHooks('/dashboard/commodity', [
  {
    path: '/',
    method: 'get',
    parameters: schemaToQueryParameters(CommoditySearchQuery),
    response: CommodityPages,
  },
  {
    path: '/:id',
    method: 'get',
    response: Commodity,
  },
  {
    path: '/:id',
    method: 'patch',
    parameters: [{ type: 'Body', name: 'body', schema: AdminCommodityForm }],
    response: AdminCommodityForm,
  },
]);
